<div class="form-page">
    <mat-card class="form-card">
        <mat-card-header>
            <div mat-card-avatar class="section-avatar section-avatar--event">
                <mat-icon>celebration</mat-icon>
            </div>
            <mat-card-title>Event Details</mat-card-title>
            <mat-card-subtitle>Basic information about the event</mat-card-subtitle>
        </mat-card-header>

        <mat-card-content>
            <form [formGroup]="eventForm" class="form-grid">

                <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Event Name</mat-label>
                    <input matInput formControlName="event_name" placeholder="e.g. Tech Expo 2025" />
                    <mat-icon matPrefix>title</mat-icon>
                    <mat-error *ngIf="eventForm.get('event_name')?.hasError('required')">Event name is
                        required</mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Address</mat-label>
                    <textarea matInput formControlName="address" rows="2" placeholder="Venue address"></textarea>
                    <mat-icon matPrefix>location_on</mat-icon>
                    <mat-error *ngIf="eventForm.get('address')?.hasError('required')">Address is required</mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline">
                    <mat-label>From Date</mat-label>
                    <input matInput [matDatepicker]="fromPicker" formControlName="from_date" placeholder="MM/DD/YYYY" />
                    <mat-datepicker-toggle matSuffix [for]="fromPicker"></mat-datepicker-toggle>
                    <mat-datepicker #fromPicker></mat-datepicker>
                    <mat-icon matPrefix>calendar_today</mat-icon>
                    <mat-error *ngIf="eventForm.get('from_date')?.hasError('required')">Start date is
                        required</mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline">
                    <mat-label>To Date</mat-label>
                    <input matInput [matDatepicker]="toPicker" formControlName="to_date" placeholder="MM/DD/YYYY" />
                    <mat-datepicker-toggle matSuffix [for]="toPicker"></mat-datepicker-toggle>
                    <mat-datepicker #toPicker></mat-datepicker>
                    <mat-icon matPrefix>event_available</mat-icon>
                    <mat-error *ngIf="eventForm.get('to_date')?.hasError('required')">End date is required</mat-error>
                </mat-form-field>

            </form>
        </mat-card-content>
    </mat-card>

    <div class="form-actions">
        <!-- <button mat-stroked-button color="warn" type="button" (click)="onReset()">
            <mat-icon>restart_alt</mat-icon> Reset All
        </button> -->
        <button mat-raised-button color="primary" type="button" (click)="onSubmit()">
            <mat-icon>save</mat-icon> Submit Registration
        </button>
    </div>
</div>